module.exports = __webpack_public_path__ + "static/edge-47131460f37ef31d4b1429640ecbb3ff.png";